import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import {Autocomplete, TextField }  from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useHistory } from "react-router-dom";

//For everyone playing along at home, this uses some different components than our other modals,
//but I kinda like this one.  Let's give a thumbs up/down to the different approaches and then
//come back and refactor for consistency

export default function FormDialog(props) {
    const [open, setOpen] = useState(false);
    const [selectedSpaces, setSelectedSpaces] = useState([])

    let history = useHistory();

    useEffect(() => {
        setOpen(props.open)
    }, [props.open])

    const handleClose = () => {
        console.log("Closed the modal")
        props.closeCallback();
    };

    const handleSubmit = () => {
        props.addToZoneCallback(selectedSpaces)
    }

    const handleNewZone = () => {
        history.push("/zones/add?site_id=" + props.site_id)
    }

    return (
        <Dialog key={props.allSpaces && props.allSpaces.length || props.allZones && props.allZones.length} open={open} onClose={handleClose}>
            <DialogTitle>Add space to zone</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {
                        props.allSpaces && props.allSpaces.length ?
                            "Choose from existing spaces to add to this zone."
                        : 
                            "Add a zone for this space."
                    }
                </DialogContentText>
                {
                    props.allSpaces && props.allSpaces.length > 0 ?
                    <Autocomplete
                        key={props.allSpaces.length}
                        id="spaces"
                        options={props.allSpaces}
                        getOptionLabel={option => option.name}
                        multiple={true}
                        isOptionEqualToValue={(option, value) => option.name === value.name}
                        renderInput={(params) => <TextField {...params} label="Select spaces for this zone" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedSpaces(newValue);
                        }}
                    />
                    :  null
                }

                {
                    props.allZones ?
                    <Autocomplete
                        id="spaces"
                        options={props.allZones}
                        getOptionLabel={option => option.name}
                        isOptionEqualToValue={(option, value) => option.name === value.name}
                        renderInput={(params) => <TextField {...params} label="Select zone for this space" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedSpaces(newValue);
                        }}
                    />
                    : null
                }
            </DialogContent>
            <DialogActions>
                {
                    props.allZones ? <Button onClick={handleNewZone}>Create Zone</Button> : null
                }
                <Button onClick={handleSubmit}>Submit</Button>
            </DialogActions>
        </Dialog>
    )
}